import React, { useEffect, useState, useRef } from 'react';
// import './Header.css';
import SDM_Month_RO_Report from './SDM_Month_RO_Report';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

//const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Dist_Month_RO_Report_data = async (params) => {  
    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/Ro/dist_month_ro_report`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }  

    return response.json();
};

const Dist_Month_RO_Report = ({ month, year}) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div

    const handleDistClick = (month, year, dist_code) => {
        setRenderContentt(null);
           
        setTimeout(() => {
            setRenderContentt(
                <SDM_Month_RO_Report month={month} year={year} dist_code={dist_code}/>
            );
        }, 10);

        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Dist_Month_RO_Report_data({month,year});

                 setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
                
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
    }, [loading, error, reportData]);

    
    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error 
        </div>
      }
    if (reportData.length === 0) {
        return <div class="mainhead" align="center">
		No data found 
 	</div>
      }  
      
           const totals = reportData.reduce(
                 (acc, item) => {
                   acc.tot_fps+=item.tot_fps || 0;
                  acc.tot_order += item.tot_order || 0;
                  acc.tot_truck += item.tot_truck || 0;
                  acc.pending += item.pending || 0;
                  acc.received += item.received || 0;
          return acc;
        },
        {
              tot_fps:0,
              tot_order:0,
              tot_truck:0,
              pending:0,
              received:0,
         
        }
      );

       
    return (
        <> 
            <table  id="myTable" align="center" width="60%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={17}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                         <td rowSpan={2}>Sl No</td>
                    	<td rowSpan={2}>District</td>
                    	<td rowSpan={2}>Total<br/>FPS</td>
	                    <td rowSpan={2}>Total<br/>Allocation<br/>Orders</td>
	                    <td colSpan={3}>Truck Chits</td>
                    </tr>
                    <tr className="tableheader">
                        <td>Total</td>
	                    <td>Received</td>
	                    <td>Pending for<br/>Receive</td>
                    </tr>
                </thead>
                <tbody>
                    { 
                        reportData.map((item, index) => (
                            <tr key={item.dist_code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>
                                    <a
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick(month, year, item.dist_code, tabHeading)}
                                    >
                                        {item.dist_name_en}
                                    </a>
                                </td>
                                <td style={{ textAlign: 'right' }}>{item.tot_fps}</td>
                                <td style={{ textAlign: 'right' }}>{item.tot_order}</td>
                                <td style={{ textAlign: 'right' }}>{item.tot_truck}</td>
                                <td style={{ textAlign: 'right' }}>{item.received}</td>
                                <td style={{ textAlign: 'right' }}>{item.pending}</td>
                            </tr>
                        ))
                     }
                    <tr className="tableheader">
                      <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_fps}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_order}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_truck}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.received}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pending}</td>
                   </tr>  
                </tbody>
           </table>
           
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default Dist_Month_RO_Report;
